module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: _vm.klass,
    attrs: {
      "aria-hidden": "true"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a7b5277e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FaIcon.vue
// module id = 1183
// module chunks = 2